import { SortPage } from "./sort-page";

export class SearchObject {

    public sort:SortPage;

    constructor(public size:number,public page:number){}
}